import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

export const DEFAULT_COMPLIANCE_NOTE = "Hindi gamot. Results may vary.";

// Small, consistent compliance/disclaimer pill used on product detail + checkout.
// Text is editable in Admin -> Nilalaman -> Products -> "Compliance note".
export const ComplianceNote = ({ text = DEFAULT_COMPLIANCE_NOTE, className, testid = "compliance-note" }) => {
  if (!text || !String(text).trim()) return null;
  return (
    <div
      className={cn(
        "inline-flex max-w-full items-center gap-1.5 rounded-md border border-border bg-muted/60 px-2.5 py-1.5 text-[11px] font-medium leading-snug text-muted-foreground",
        className
      )}
      role="note"
      data-testid={testid}
    >
      <ShieldCheck className="h-3.5 w-3.5 shrink-0 text-primary/70" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
};
